<template>
	<el-container style="height: 100vh;">
		<el-aside width="200px" style="background-color: #343a40; height: 100%;">
			<!-- 系统Logo与标题 -->
			<div class="system-logo">
				<!-- <img :src="logo" alt="系统Logo" /> -->
				<span>叁两声管理后台</span>
			</div>

			<!-- 左侧菜单 -->
			<el-menu
			        :default-active="activeMenu"
			        router
			        unique-opened
			        class="el-menu-vertical-demo"
			        background-color="#343a40"
			        text-color="#fff"
			        active-text-color="#ffd04b"
			      >
				<!-- <el-menu-item index="/admin/userManagement">
					<i class="el-icon-user"></i>
					<span>用户管理</span>
				</el-menu-item> -->
				<el-menu-item index="/admin/center">
				  <i class="el-icon-user"></i>
				  <span>个人资料</span>
				</el-menu-item>
				
				<el-menu-item index="/admin/recommend">
				  <i class="el-icon-house"></i>
				  <span>首页管理</span>
				</el-menu-item>
				
				<el-menu-item index="/admin/works">
				  <i class="el-icon-video-camera"></i>
				  <span>作品管理</span>
				</el-menu-item>
				
				<el-menu-item index="/admin/types">
				  <i class="el-icon-collection-tag"></i>
				  <span>类别管理</span>
				</el-menu-item>
				<el-menu-item index="/admin/about">
				  <i class="el-icon-info"></i>
				  <span>公司简介</span>
				</el-menu-item>
				<el-menu-item index="/admin/teamMembers">
				  <i class="el-icon-user-solid"></i>
				  <span>团队成员</span>
				</el-menu-item>
			</el-menu>
		</el-aside>

		<el-container>
			<el-header>
				<h1>叁两声管理后台</h1>

				<!-- 用户名 + 退出登录 -->
				<div class="user-info">
					<span class="username">欢迎，{{ username }}</span>
					<el-button type="text" @click="handleLogout" class="logout-button">
						<img src="@/assets/logout.png" alt="退出" />
					</el-button>
				</div>
			</el-header>

			<el-main>
				<router-view />
			</el-main>
		</el-container>
	</el-container>
</template>

<script>
	import {
		Message
	} from 'element-ui';
	import logo from '@/assets/R.png';

	export default {
		name: "AdminLayout",
		data() {
			return {
				logo, // 将导入的 logo 变量挂载到 data 中供模板使用
			};
		},
		computed: {
			username() {
				return localStorage.getItem('username') || '未知用户';
			},
			activeMenu() {
			      return this.$route.path;
			    }
		},
		methods: {
			handleLogout() {
				localStorage.removeItem('token');
				this.$router.push('/');
				Message.success("欢迎下次访问!");
			}
		}
	}
</script>

<style scoped>
/* 头部样式 */
.el-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-image: linear-gradient(to right, #00f2fe, #ff39b0);
  color: white;
  padding: 0 20px;
  height: 60px;
  line-height: 60px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  font-family: 'Arial', sans-serif;
}

.el-header h1 {
  margin: 0;
  font-size: 20px;
  font-weight: normal;
}

.user-info {
  display: flex;
  align-items: center;
}

.username {
  margin-right: 15px;
  font-size: 14px;
}

.logout-button img {
  width: 20px;
  height: 20px;
}

.logout-button:hover {
  opacity: 0.8;
}

/* 系统 Logo 区域 */
.system-logo {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px 0;
  background-color: #2c3e50;
  color: white;
  font-weight: bold;
  font-size: 16px;
}

.system-logo img {
  width: 30px;
  height: 30px;
  margin-right: 10px;
}

/* 菜单高度占满剩余空间 */
.el-menu-vertical-demo {
  max-height: calc(100% - 60px);
  overflow-y: auto;
  border-right: none;
}

/* 自定义激活菜单项的样式 - 增强版 */
.el-menu-item.is-active {
  background-color: #55b4e4 !important; /* 改为更醒目的蓝色 */
  color: #fff  !important;
  border-radius: 4px;
  margin: 4px 8px;
  width: auto;
}

/* 鼠标悬停样式 */
.el-menu-item:hover {
  background-color: rgba(24, 225, 247, 1.0) !important;
}



/* 菜单项默认样式 */
.el-menu-item {
  margin: 4px 8px;
  border-radius: 4px;
  width: auto;
  transition: all 0.3s;
}
</style>